import { render, staticRenderFns } from "./view-all-images.vue?vue&type=template&id=2204732e&scoped=true&"
import script from "./view-all-images.vue?vue&type=script&lang=ts&"
export * from "./view-all-images.vue?vue&type=script&lang=ts&"
import style0 from "./view-all-images.vue?vue&type=style&index=0&id=2204732e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204732e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2204732e')) {
      api.createRecord('2204732e', component.options)
    } else {
      api.reload('2204732e', component.options)
    }
    module.hot.accept("./view-all-images.vue?vue&type=template&id=2204732e&scoped=true&", function () {
      api.rerender('2204732e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/estates/view-all-images.vue"
export default component.exports